import { gemReport } from '../../config/filters';

const config = {
  GEM_REPORT_FILTERS: gemReport,
  GEM_REPORT_PAGE_ID: 'gemReport'
};

export default config;
